import { render, staticRenderFns } from "./ShowDocsDialog.vue?vue&type=template&id=75f80dfa&scoped=true"
import script from "./ShowDocsDialog.vue?vue&type=script&lang=js"
export * from "./ShowDocsDialog.vue?vue&type=script&lang=js"
import style0 from "./ShowDocsDialog.vue?vue&type=style&index=0&id=75f80dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f80dfa",
  null
  
)

export default component.exports